import { HaitianCreole } from './ht'

import { default as English } from 'flatpickr/dist/l10n/default'
import { Spanish } from 'flatpickr/dist/l10n/es'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'

export default function loadTranslation(locale: string) {
  switch (locale) {
    case 'ht':
      return HaitianCreole
    case 'es':
      return Spanish
    case 'vi':
      return Vietnamese
    case 'en':
    default:
      return English
  }
}
